module.exports = __webpack_public_path__ + "static/media/ProductiveForestAreaWorld.16643a59.gif";